import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Centralized configuration for all API queries
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000, // 30 seconds
    },
  },
});
